export enum FullfillmentType {
  Deliver,
  Pickup,
}
